module.exports = __webpack_public_path__ + "media/images/mailer/person-24-light-1a64efc48570ef7541429fc623b08839.png";